import {ProvisioningType} from '@frontend/shared-api';

export const CAPABILITY_LEVELS = [0, 1, 2, 3, 4] as const;
export type CapabilityLevel = (typeof CAPABILITY_LEVELS)[number];

const CAPABILITY_STEP = 0.25;

export const PROVISIONING_FACTORS: Record<ProvisioningType, number> = {
  [ProvisioningType.PRODUCT_STANDARD]: 1,
  [ProvisioningType.CONFIGURATION]: 1,
  [ProvisioningType.ADD_ON_MODULE]: 0.9,
  [ProvisioningType.PARTNER_SOLUTION]: 0.8,
  [ProvisioningType.CUSTOMIZING]: 0.75,
  [ProvisioningType.THIRD_PARTY_SYSTEM]: 0.65,
  [ProvisioningType.ROADMAP]: 0.2,
  [ProvisioningType.NOT_AVAILABLE]: 0,
};

export function allowedProvisioningTypes(
  capabilityLevel: CapabilityLevel | null,
): ProvisioningType[] {
  if (capabilityLevel === null) {
    return Object.values(ProvisioningType);
  }
  if (capabilityLevel === 0) {
    return [ProvisioningType.NOT_AVAILABLE];
  }
  return Object.values(ProvisioningType).filter((type) => type !== ProvisioningType.NOT_AVAILABLE);
}

export function reconcileCapabilityLevel(
  capabilityLevel: CapabilityLevel | null,
  provisioningType: ProvisioningType | null,
): CapabilityLevel | null {
  if (provisioningType === ProvisioningType.NOT_AVAILABLE) {
    return 0;
  }
  if (provisioningType !== null && capabilityLevel === 0) {
    return null;
  }
  return capabilityLevel;
}

export function reconcileProvisioningType(
  capabilityLevel: CapabilityLevel | null,
  provisioningType: ProvisioningType | null,
): ProvisioningType | null {
  if (capabilityLevel === 0) {
    return ProvisioningType.NOT_AVAILABLE;
  }
  if (capabilityLevel !== null && provisioningType === ProvisioningType.NOT_AVAILABLE) {
    return null;
  }
  return provisioningType;
}

export function twoStageFactor(
  capabilityLevel: CapabilityLevel | null,
  provisioningType: ProvisioningType | null,
): number | null {
  if (capabilityLevel === null || provisioningType === null) {
    return null;
  }
  return Number(
    (capabilityLevel * CAPABILITY_STEP * PROVISIONING_FACTORS[provisioningType]).toFixed(4),
  );
}
